/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronsOutsideVertically: {
  name: 'chevrons-outside-vertically';
  data: string;
} = {
  name: 'chevrons-outside-vertically',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.707 4.293a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L12 6.414l3.293 3.293a1 1 0 0 0 1.414-1.414l-4-4Zm0 15.414a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L12 17.586l3.293-3.293a1 1 0 0 1 1.414 1.414l-4 4Z" fill="currentColor"/></svg>`,
};
